import * as Yup from 'yup';

export default Yup.object().shape({
  deptId: Yup.string().required('Department is required'),
  serialNo: Yup.string()
    .required('Serial number is required')
    .max(50, 'Maximum length is 50 characters'),
  sensorPollRate: Yup.number()
    .required('Normal update (sec) is required')
    .typeError('Normal update (sec) must be a integer')
    .integer('Normal update (sec) must be a integer'),
  alarmUpdate: Yup.number()
    .required('Alarm update (sec) is required')
    .typeError('Alarm update (sec) must be a integer')
    .integer('Alarm update (sec) must be a integer'),
  description: Yup.string().max(16, 'Maximum length is 16 characters'),
  mktActivationEnergy: Yup.string()
    .required('MKT Activation Energy is required')
    .matches(/^\d*\.{1}\d*$/, 'MKT Activation Energy must be a decimal number'),
});
